module.exports = __webpack_public_path__ + "img/Einheit.3811a9ba.svg";